import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

export const selectMarketYoyGrowthExpectationUserInfo = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => state.userInfo
)
